import { render, staticRenderFns } from "./ProcessesPage.vue?vue&type=template&id=a05b8532&scoped=true"
import script from "./ProcessesPage.vue?vue&type=script&lang=js"
export * from "./ProcessesPage.vue?vue&type=script&lang=js"
import style0 from "./ProcessesPage.vue?vue&type=style&index=0&id=a05b8532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05b8532",
  null
  
)

export default component.exports